export default __webpack_public_path__ + "static/media/piñosChill.1bc85a97.jpeg";